import { Globe, Users, Package, Clock } from 'lucide-react'

const stats = [
  { icon: Globe, value: '40+', label: 'Markets served' },
  { icon: Users, value: '500+', label: 'Vetted producers' },
  { icon: Package, value: '730+', label: 'Products in catalog' },
  { icon: Clock, value: '24h', label: 'Quote turnaround' }
]

export function StatsStrip() {
  return (
    <section className="border-b border-brand-slate/10 bg-white px-4 py-10 sm:px-6 lg:px-8">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-6 lg:grid-cols-4">
        {stats.map((s) => (
          <div key={s.label} className="flex items-center gap-4">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand-gold/15">
              <s.icon className="h-6 w-6 text-brand-gold" />
            </div>
            <div>
              <div className="font-display text-2xl font-bold text-brand-navy sm:text-3xl">{s.value}</div>
              <div className="text-xs font-medium uppercase tracking-wider text-brand-slate sm:text-sm">{s.label}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
